<div class="dropdown">
    <div class="dropdown-content" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="pl-4" fxLayout="column" fxLayoutAlign="start start">
            <div fxLayout="row" fxLayoutAlign="start center">
                <mat-icon [icIcon]="icInfo"></mat-icon>
                <button (click)="changeRoute('/cms/business-group')"  class="p-2">Manager Home</button>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center">

                <mat-icon [icIcon]="icBriefCase"></mat-icon>
                <button (click)="changeRoute('/cms/business-group/add-business-group')" class="p-2">Add Business Group </button>


            </div>

        </div>



        <!-- <button [matMenuTriggerFor]="settingsMenu"
              mat-icon-button
              matTooltip="Settings"
              matTooltipPosition="before"
              type="button">
        <mat-icon [icIcon]="icSettings" class="notifications-header-icon"></mat-icon>
      </button> -->
    </div>


    <div  *ngIf="switchToitems.length > 0" class="dropdown-footer overflow-auto" fxLayout="column" fxLayoutAlign="space-between start">
        <!-- <div class="dropdown-heading">Switch to</div> -->
        <div class="p-1" fxLayout="row" fxLayoutAlign="start center">
            <mat-icon [icIcon]="icSwitch"></mat-icon>
            <h5 class="p-2">Switch to</h5>
        </div>

        <div class="overflow-scroll w-full">
            <div *ngFor="let items of switchToitems" fxLayout="column" fxLayoutAlign="space-between start">
                <div fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon [icIcon]="icRoute"></mat-icon>
                    <a (click)="switchTo(items.bg_id)" class="dropdown-footer-select w-full" mat-button type="button">
                        {{items.groupname}}
                    </a>
                </div>
    
            </div>
        </div>
        

        <!-- <a   color="primary" mat-button>LOGOUT</a> -->
    </div>
</div>